var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPhoneIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4537 2.3153L4.40233 0.75546C3.87664 0.131524 2.82527 -0.284433 2.08931 0.235513C-3.5881 4.2911 7.34617 19.3695 12.9184 15.314C13.6544 14.898 13.6544 13.7541 13.1287 13.0262C12.7082 12.4023 12.4979 12.0903 12.0773 11.5703C11.6568 10.8424 10.7106 10.7384 9.9746 11.1544L8.81809 11.9863C7.45131 13.0262 2.50986 6.1629 3.98178 5.12301L5.13829 4.2911C5.76911 3.87514 5.87425 2.93924 5.4537 2.3153Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phoneIcon.82fee052.svg";
export { ForwardRef as ReactComponent };